import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageTemplate, Box, PageTitle } from '../PageTemplate';
import { CreateEventForm } from './';
import {QueryString} from '../../helper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faPlusCircle, faWineGlass} from '@fortawesome/fontawesome-free-solid';
import './createEvent.scss';

class CreateEventPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventType: 'normal'
        }
    }

    componentDidMount() {
        const {location} = this.props;
        this.parseUrlQuery(location.search);
    }

    componentDidUpdate(prevProps) {
        const {location} = this.props;

        if(prevProps.location.search !== location.search) {
            this.parseUrlQuery(location.search);
        }
    }

    parseUrlQuery(url) {
        const {type} = QueryString.parse(url);
        
        this.setState({eventType: type === 'demo' ? 'demo' : 'normal'});
    }

    render() {     
        const {eventType} = this.state;
        return (
            <PageTemplate id="createEventPage">
                <PageTitle>
                    <FontAwesomeIcon icon={faPlusCircle}/>&nbsp;
                    {eventType === 'demo' ? 'אירוע לדוגמא חדש' : 'אירוע חדש'}
                    
                </PageTitle>
                <div className="bgIcon">
                    <FontAwesomeIcon icon={faWineGlass}/>
                </div>
                <Box col="2">
                    <CreateEventForm eventType={eventType} />
                </Box>
            </PageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        createEvent: state.createEventReducer
    }
}

const CreateEventPageWithRedux = withRouter(connect(mapStateToProps)(CreateEventPage));

export {CreateEventPageWithRedux as CreateEventPage};


// WEBPACK FOOTER //
// ./src/components/CreateEventPage/CreateEventPage.jsx